import { useState } from "react";
import { Hero } from "@/components/home/Hero";
import { StatsBar } from "@/components/home/StatsBar";
import { RegistrySearch } from "@/components/home/RegistrySearch";
import { FeaturedProfiles } from "@/components/home/FeaturedProfiles";
import { ProfilePanel } from "@/components/home/ProfilePanel";
import { RankingsHighlight } from "@/components/home/RankingsHighlight";
import { EventsSection, Editorial } from "@/components/home/EventsEditorial";
import { PromoCards, Partners, Newsletter } from "@/components/home/Promos";
import { IndexTicker, ClassificationUniverse, useOverview } from "@/components/home/Classifications";
import { GenreChartsHome } from "@/pages/Charts";

export default function Home() {
  const [selected, setSelected] = useState(null);
  const overview = useOverview();
  return (
    <main data-testid="home-page">
      <IndexTicker data={overview} />
      <Hero />
      <StatsBar />
      <ClassificationUniverse data={overview} />
      <RankingsHighlight />
      <GenreChartsHome />
      <RegistrySearch />
      <div className="container-wei grid xl:grid-cols-[minmax(0,1fr)_540px] gap-6 items-start">
        <FeaturedProfiles onSelect={setSelected} selected={selected} />
        <div className="xl:py-8 min-w-0" data-testid="featured-panel-wrap">{selected && <ProfilePanel slug={selected.slug} />}</div>
      </div>
      <EventsSection />
      <Editorial />
      <PromoCards />
      <Partners />
      <Newsletter />
    </main>
  );
}
